import React from "react";

import { Button, ButtonGroup, Icon } from "aible";
import Select from "react-select";

import { Tabs } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMagic,
  faAward,
  faBrain,
  faBars,
  faTrophy,
  faArrowUp,
  faArrowDown,
  faCheckCircle,
  faTimesCircle,
  faThumbsUp,
  faThumbsDown,
  faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";

import { DeleteButton, DeleteButtonMedium } from "components/Home/Utils/Utils";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { LineInput } from "components/Inputs/LineInput";
import MaxChart from "components/FeatureChart/MaxChart";
import PieChart from "components/FeatureChart/PieChart";

import AibleStep from "components/CreateWizard/AibleStep";
import ModelTile from "containers/Tiles/ModelTile";
import ForecastChart from "containers/ForecastChart/PredictionChart";

import ModelsChart from "components/nHotdogChart/ModelsChart";
import SHotdogChart from "components/nHotdogChart/sHotdogChart";

import PredictionDriversCompanion from "components/FeatureChart/PredictionDriversCompanion";

import styles from "./style.module.css";

import { getMinMaxFromString, replaceName } from "containers/Predict/reducer";
import { isEnabled } from "utils/featureFlags";

export default class FeatureChartConsumer extends React.Component {
  constructor(props) {
    super(props);
  }

  state = {
    minimize: this.props?.isChat ? true : false
  };

  findBucket(field, val) {
    const { fields, selectedScenario } = this.props;

    if (fields?.[field]?.isNumeric || fields?.[field]?.type === "number") {
      const values = selectedScenario?.predictModels?.[0]?.features?.percentages?.[field]?.index ?? [];
      const retBucket = values.find((v) => {
        const minMax = getMinMaxFromString({ label: field }, v);
        if (minMax.min !== undefined && minMax.max !== undefined) {
          if (minMax.min === -Infinity && val === "-inf") {
            return true;
          }
          if (minMax.max === Infinity && val === "inf") {
            return true;
          }
          return val > minMax.min && val < minMax.max;
        }
        return false;
      });
      if (retBucket) {
        return retBucket;
      }
    }

    return val;
  }

  renderPredict() {
    const {
      colSelections,
      handlePredict,
      handleRestfulDeploy,
      scenarios,
      selectedScenario,
      isPredictLoading,
      featureBars,
      isHideSelect,
      successStrings,
      deployments,
      outcome,
      trueAction,
      falseAction,
      models,
      updateChooseModel,
      firstModel,
      project,
      isQuickRun,
      predictModels,
      updatePredictModels,
      updateScenarioIndex,
      updateFieldOption,
      updateFieldOptions,
      isContinuous,
      resetMinMax,
      updateHoverValue,
      chooseScenario,
      scenarioIndex,
      updateAllPredictions,
      model,
      fields,
      minMax,
      deleteScenario,
      isConsumer,
      selected,
      projectDeployment,
      ignored,
      optimizeGoal,
      updateOptimizeGoal,
      isProjectDeployedScenario,
      projectDeployedScenarioId,
      projectViewingScenarioId,
      isChat,
      isChatPanel,
      forcePrediction
    } = this.props;

    const optimizeGoalOptions = [
      { label: "Maximize", value: "MAXIMIZE" },
      { label: "Minimize", value: "MINIMIZE" }
    ];

    const deployment = isConsumer
      ? projectDeployment
      : deployments && model
        ? deployments.filter((d) => d.model_name === model.id) &&
          deployments.filter((d) => d.model_name === model.id)[0]
        : undefined;

    const isMinMax = minMax && minMax.field !== undefined;

    const deploymentsStarting = deployments
      ? deployments.filter((d) => d.status !== "RUNNING" && d.status !== "ERROR").length
      : 0;

    const deploymentError = deploymentsStarting === 0 && deployment && deployment.status === "ERROR";

    const scenario = selectedScenario;

    const prediction =
      forcePrediction !== undefined && scenarioIndex === "message"
        ? forcePrediction
        : isChat && forcePrediction !== undefined
          ? forcePrediction
          : scenario
            ? scenario.predictions.filter((p) =>
                isConsumer ? firstModel && p.model === firstModel.id : selected && p.model === selected
              )
            : undefined;

    let isNewPredict = scenarioIndex === "new" || scenarioIndex === undefined;

    let options = [];
    const displayFields = {};

    for (let bar of featureBars) {
      const field = fields && fields[bar.label];

      if (field !== undefined) {
        displayFields[bar.label] = field;
      }

      if (field && field.type !== "number" && bar.values) {
        Object.keys(bar.values).forEach((v) =>
          options.push({
            label: bar.label + ": " + replaceName(v),
            value: v,
            field: bar.label
          })
        );
      }

      if (field && field.type === "number" && bar.values) {
        Object.keys(bar.values).forEach((v) => {
          options.push(getMinMaxFromString(bar, v));
        });

        //options = options.sort((a, b) => a.min - b.min);
      }

      if (field === undefined) {
        Object.keys(bar.values).forEach((v) =>
          options.push({
            label: bar.label + ": " + replaceName(v),
            value: v,
            field: bar.label
          })
        );
      }
    }

    const selOptions = colSelections
      ? Object.keys(colSelections)
          .filter((c) => colSelections[c] !== "Blank-Aible")
          .map((c) => ({ field: c, value: colSelections[c] }))
      : undefined;

    let chooseOptions = [];

    if (selOptions) {
      for (const option of selOptions) {
        for (const tOption of options) {
          if (option.field === tOption.field) {
            if (option.value === tOption.value) {
              chooseOptions.push(tOption);
            } else if (
              typeof option.value !== "string" &&
              typeof tOption.value !== "string" &&
              ((tOption.min && option.value > tOption.min && option.value < tOption.max) ||
                (option.value === tOption.min && option.value === tOption.max))
            ) {
              chooseOptions.push(tOption);
            }
          }
        }
      }
    }

    chooseOptions = chooseOptions.map((e) => ({
      ...e,
      fieldValue: e.value,
      value: e.label
    }));

    const firstThreshold = model
      ? model.confusionMatrix !== undefined
        ? model.confusionMatrix.threshold !== undefined
        : model.maxIteration
          ? model.maxIteration.threshold
          : undefined
      : undefined;

    const isTruePredict =
      firstThreshold !== undefined && prediction && prediction.length >= 1
        ? prediction[0].probability >= firstThreshold * 100
        : false;

    const isMinimize = this.state.minimize;

    const truePredictions = (prediction || [])
      .filter((p) => p.probability >= firstThreshold * 100)
      .sort((a, b) => b.probability - a.probability); // reversed

    const falsePredictions = (prediction || [])
      .filter((p) => p.probability < firstThreshold * 100)
      .sort((a, b) => b.probability - a.probability);

    return (
      <div className={styles.predictHolder}>
        <div className={styles.miniOptions} style={this.state.minimize ? { padding: "0px" } : {}}>
          <div style={{ width: "100%" }}>
            <div className={styles.miniSelect + " " + (isMinimize ? styles.isMinimized : "")}>
              <div>{"Specify a What-If:"}</div>
              <Select
                id="tabPredictSelect"
                options={options ? options : []}
                onChange={(val) => updateFieldOptions(val)}
                value={chooseOptions}
                isMulti
                placeholder={"Click to specify a What-If"}
              />
            </div>
            {displayFields && (
              <React.Fragment>
                <div
                  className={
                    styles.miniSelect + " " + styles.secondSelect + " " + (isMinimize ? styles.isMinimized : "")
                  }
                >
                  <div>{"Optimize by changing:"}</div>
                  <div className={styles.sHolder}>
                    <Select
                      key={minMax ? minMax.field : "none"}
                      options={Object.keys(displayFields)
                        .filter((f) => f !== outcome && !ignored[f])
                        .map((f) => ({ label: f, value: f }))}
                      value={minMax && minMax.field ? { label: minMax.field, value: minMax.field } : undefined}
                      onChange={(val) =>
                        val === null ? resetMinMax(undefined) : updateFieldOption(val.value, "@_@Scenario@_@")
                      }
                      placeholder={"Select Field"}
                      isClearable
                    />
                  </div>
                </div>
              </React.Fragment>
            )}
            {isChat ? (
              <div />
            ) : (
              <a
                style={{
                  marginLeft: this.state.minimize ? "10px" : undefined
                }}
                onClick={() => this.setState({ minimize: !this.state.minimize })}
              >
                {this.state.minimize === true ? "Show Subgroup Controls" : "Hide Subgroup Controls"}
              </a>
            )}
            <div style={{ minHeight: "10px" }} />
            {isChat ? (
              <div />
            ) : (
              isNewPredict && (
                <div className={styles.pButton}>
                  <Button
                    type="primary"
                    className={styles.bigButton}
                    onClick={() => handlePredict(scenario ? scenario.id : undefined, isConsumer ? undefined : selected)}
                    disabled={chooseOptions.length === 0 && minMax === undefined}
                    title={
                      chooseOptions.length === 0 && minMax === undefined
                        ? "Select values to predict"
                        : isContinuous
                          ? "Predict " + outcome
                          : "Predict"
                    }
                  >
                    {isContinuous ? "Predict " + outcome : "Predict"}
                  </Button>
                </div>
              )
            )}
            {isChat !== true && scenario && scenario.isLoading > 0 ? (
              <div className={styles.miniDeployStarter}>
                {deploymentError ? "" : <LoadingIndicator style={{ margin: "0px", marginBottom: "0px" }} />}
                {deploymentsStarting !== 0 && <div className={styles.pMsg}>{"Starting deployment..."}</div>}
                {deploymentsStarting !== 0 && <div className={styles.pMsg}>{"This can take up to 5 minutes..."}</div>}
                {deploymentError ? (
                  <div className={styles.pMsg}>{"Error Deploying"}</div>
                ) : (
                  <div className={styles.pMsg}>{"Calculating prediction..."}</div>
                )}
              </div>
            ) : prediction ? (
              !isNewPredict && prediction.length === 0 ? (
                <div className={styles.newHolder}>
                  <Button
                    type="primary"
                    className={styles.bigButton}
                    onClick={() => handlePredict(scenario ? scenario.id : undefined, isConsumer ? undefined : selected)}
                    disabled={chooseOptions.length === 0 && minMax === undefined}
                    title={
                      chooseOptions.length === 0 && minMax === undefined
                        ? "Select values to predict"
                        : isContinuous
                          ? "Predict " + outcome
                          : "Calculate What-If"
                    }
                  >
                    {isContinuous ? "Predict " + outcome : "Calculate What-If"}
                  </Button>
                </div>
              ) : prediction.length === 1 && prediction[0].value === undefined ? (
                isContinuous !== true ? (
                  <div className={styles.miniPredictionCircle}>
                    <div className={styles.circleHolder}>
                      <FontAwesomeIcon
                        icon={isTruePredict ? faCheckCircle : faTimesCircle}
                        className={isTruePredict ? styles.goodColor : styles.badColor}
                      />
                    </div>
                    <div className={styles.takeAction + " " + (isTruePredict ? styles.goodColor : styles.badColor)}>
                      {isTruePredict ? trueAction : falseAction}
                    </div>
                    <div className={styles.profScore}>
                      <div>{"Prediction Score"}</div>
                      <div>{prediction[0].probability.toFixed(2) + "%"}</div>
                    </div>
                    <div className={styles.profBar}>
                      <div
                        className={isTruePredict ? styles.goodColorBack : styles.badColorBack}
                        style={{
                          width: prediction[0].probability.toFixed(2) + "%"
                        }}
                      />
                    </div>
                    {firstThreshold !== undefined && (
                      <React.Fragment>
                        <div className={styles.profScore} style={{ marginTop: "10px" }}>
                          <div>{"Threshold"}</div>
                          <div>{(Math.min(firstThreshold, 1) * 100).toFixed(2) + "%"}</div>
                        </div>
                        <div className={styles.profBar}>
                          <div
                            className={styles.aibleColorBack}
                            style={{
                              width: (Math.min(firstThreshold, 1) * 100).toFixed(2) + "%"
                            }}
                          />
                        </div>
                      </React.Fragment>
                    )}
                  </div>
                ) : (
                  <div className={styles.miniPrediction}>
                    <div className={styles.emptyPie}>
                      <div className={styles.predMsgCont}>{Number(prediction[0].prediction).toFixed(4)}</div>
                    </div>
                    <div className={styles.pMsg}>{"Predicted " + outcome}</div>
                  </div>
                )
              ) : !isContinuous && !isQuickRun ? (
                <div className={styles.multiPredict}>
                  {truePredictions.length > 0 && (
                    <div className={styles.miniPredictionCircle}>
                      <div className={styles.circleHolder}>
                        <FontAwesomeIcon icon={faCheckCircle} className={styles.goodColor} />
                      </div>
                      <div className={styles.takeAction}>{trueAction}</div>
                      <div className={styles.valHolder} style={isChat ? { maxHeight: "initial" } : {}}>
                        {truePredictions.map((p, i) => (
                          <React.Fragment key={i}>
                            <div className={styles.profScore}>
                              <div>
                                {this.findBucket(p.field, p.value) +
                                  (p?.otherFields === undefined || p?.otherFields?.length === 0
                                    ? ""
                                    : ", when " +
                                      p?.otherFields.reduce(
                                        (a, b, c) =>
                                          a +
                                          (b?.field + " is " + b?.value + (c < p?.otherFields?.length - 1 ? ", " : "")),
                                        ""
                                      ))}
                              </div>
                              <div>{p.probability.toFixed(2) + "%"}</div>
                            </div>
                            <div className={styles.profBar}>
                              <div
                                className={styles.goodColorBack}
                                style={{
                                  width: p.probability.toFixed(2) + "%"
                                }}
                              />
                              <div
                                style={{
                                  position: "relative",
                                  top: "-12px",
                                  left: `${Math.min(firstThreshold, 1) * 100}%`,
                                  width: "2px",
                                  height: "14px",
                                  backgroundColor: "#512f77"
                                }}
                              />
                            </div>
                          </React.Fragment>
                        ))}
                      </div>
                    </div>
                  )}
                  {falsePredictions.length > 0 && (
                    <div className={styles.miniPredictionCircle}>
                      <div className={styles.circleHolder}>
                        <FontAwesomeIcon icon={faTimesCircle} className={styles.badColor} />
                      </div>
                      <div className={styles.takeAction}>{falseAction}</div>
                      <div className={styles.valHolder} style={isChat ? { maxHeight: "initial" } : {}}>
                        {falsePredictions.map((p, i) => (
                          <React.Fragment key={i}>
                            <div className={styles.profScore}>
                              <div>
                                {this.findBucket(p.field, p.value) +
                                  (p?.otherFields === undefined || p?.otherFields?.length === 0
                                    ? ""
                                    : ", when " +
                                      p?.otherFields.reduce(
                                        (a, b, c) =>
                                          a +
                                          (b?.field + " is " + b?.value + (c < p?.otherFields?.length - 1 ? ", " : "")),
                                        ""
                                      ))}
                              </div>
                              <div>{p.probability.toFixed(2) + "%"}</div>
                            </div>
                            <div className={styles.profBar}>
                              <div
                                className={styles.badColorBack}
                                style={{
                                  width: p.probability.toFixed(2) + "%"
                                }}
                              />
                              <div
                                style={{
                                  position: "relative",
                                  top: "-12px",
                                  left: `${Math.min(firstThreshold, 1) * 100}%`,
                                  width: "2px",
                                  height: "14px",
                                  backgroundColor: "#512f77"
                                }}
                              />
                            </div>
                          </React.Fragment>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <MaxChart
                  valueOptions={options.filter((option) => option.field === minMax?.field)}
                  outcome={outcome}
                  prediction={prediction}
                  threshold={firstThreshold * 100}
                  successStrings={successStrings}
                  isQuickRun={isQuickRun}
                  updateHoverValue={(value) => updateHoverValue(value)}
                />
              )
            ) : (
              <div />
            )}
          </div>
        </div>
        {isChat ? (
          <div />
        ) : scenarios !== undefined && scenarios.length > 0 ? (
          <div className={styles.chartButtonHolderMini}>
            <div className={styles.buttonTitleMini} style={{ fontSize: "13px" }}>
              {"What-If:"}
            </div>
            <ButtonGroup>
              <Button
                onClick={() => updateScenarioIndex("new")}
                type="secondary"
                active={isNewPredict && scenarios && scenarios.length > 0}
                disabled={scenarios === undefined || scenarios.length === 0}
                style={{
                  fontSize: "13px",
                  lineHeight: "initial",
                  padding: "6px"
                }}
              >
                {"New"}
              </Button>
              {forcePrediction !== undefined && (
                <Button
                  onClick={() => updateScenarioIndex("message")}
                  type="secondary"
                  active={scenarioIndex === "message"}
                  style={{
                    fontSize: "13px",
                    lineHeight: "initial",
                    padding: "6px"
                  }}
                >
                  {"Message"}
                </Button>
              )}
              {scenarios &&
                Object.keys(scenarios).map((s, i) => {
                  const scen = scenarios[s];

                  return (
                    <Button
                      onClick={() => chooseScenario(scenarios[s])}
                      key={i}
                      type="secondary"
                      active={scenarioIndex === scen.id}
                      style={{
                        fontSize: "13px",
                        lineHeight: "initial",
                        padding: "6px"
                      }}
                    >
                      {scen.isLoading <= 0 ? scen.id + 1 : "..."}
                    </Button>
                  );
                })}
            </ButtonGroup>
            <div style={{ paddingLeft: "10px" }} />
            {scenarioIndex !== "new" ? (
              <DeleteButtonMedium type={"current scenario"} clickHandler={deleteScenario} />
            ) : (
              ""
            )}
          </div>
        ) : (
          <div className={styles.chartButtonHolderMini}>
            <div className={styles.buttonTitleMini} style={{ fontSize: "13px" }}>
              {"What-If:"}
            </div>
            <ButtonGroup>
              <Button
                onClick={() => updateScenarioIndex("new")}
                type="secondary"
                active={true}
                style={{
                  fontSize: "13px",
                  lineHeight: "initial",
                  padding: "6px"
                }}
              >
                {"New"}
              </Button>
              {forcePrediction !== undefined && (
                <Button
                  onClick={() => updateScenarioIndex("message")}
                  type="secondary"
                  active={scenarioIndex === "message"}
                  style={{
                    fontSize: "13px",
                    lineHeight: "initial",
                    padding: "6px"
                  }}
                >
                  {"Message"}
                </Button>
              )}
            </ButtonGroup>
          </div>
        )}
        {!isNaN(projectDeployedScenarioId) && !isProjectDeployedScenario ? (
          <div className={styles.newFrontier}>
            <div className={styles.nHeader}>
              {projectDeployedScenarioId === projectViewingScenarioId
                ? "Your settings have changed from the deployed scenario"
                : "You are not viewing the currently deployed scenario"}
            </div>
            {/* <div className={styles.nSub}>
              {
                "Your organization has deployed a different model or settings"
              }
            </div> */}
            {/* <div className={styles.nButton}>
              <Button onClick={() => updateAllPredictions()}>
                {"Update Saved Predictions"}
              </Button>
            </div> */}
          </div>
        ) : project && project.settings && project.settings.isNewFrontier && scenarios && scenarios.length > 0 ? (
          <div className={styles.newFrontier}>
            <div className={styles.nHeader}>{"Your organization settings have changed"}</div>
            <div className={styles.nSub}>{"Your organization has deployed a different model or new settings"}</div>
            <div className={styles.nButton}>
              <Button onClick={() => updateAllPredictions()}>{"Update Saved What-Ifs"}</Button>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
    );
  }

  render() {
    const {
      id,
      models,
      model,
      updateSelectedModel,
      isModelSelect,
      isSmall,
      isHideSelect,
      isResults,
      isTableau,
      isQuickRun,
      featureBars,
      modelBars,
      isTabMini,
      fieldSelect,
      colSelections,
      valueSelect,
      outcome,
      rowCount,
      onClick,
      label,
      isForecast,
      isProjectOverview,
      isConsumer,
      hideRight,
      fields,
      fieldValueCounts,
      ignored,
      hideTitle,
      predictMode,
      hoverValue,
      featureStyle,
      updateFieldSelect,
      updateValueSelect,
      updateFeatureSelection,
      updateFieldOption,
      updateHoverValue,
      updatePredictMode,
      aibleBusiness,
      showModelFit,
      isContinuous,
      projectId,
      isNext,
      suppressSelection,
      singleWindowMode,
      isNoInteractions,
      isChat,
      isChatPanel,
      noBackground,
      hideHotdogChart
    } = this.props;

    if (models === undefined || model === undefined) {
      return <div />;
    }

    const hasFeatures =
      predictMode === "forecast" ||
      predictMode === "predict" ||
      (model.hasFeatures === true && model.featureInfo && model.featureInfo.length > 0);

    if ((isSmall && hasFeatures !== true) || (predictMode === "predict" && model && model.id === "Current State")) {
      return <div className={styles.notAvailable}>{"Not available for this model"}</div>;
    } else if (hasFeatures !== true) {
      return (
        <div style={{ height: "100%", width: "100%" }}>
          <div className={styles.cTitle}>{"Top Model Drivers"}</div>
          <div className={styles.notAvailable}>{"Not available for this model"}</div>
        </div>
      );
    }

    const determineVisualizationToShow = () => {
      if (isNext && fieldSelect === undefined) return null;
      return <PredictionDriversCompanion {...this.props} clearSelect={() => updateFieldSelect(undefined)} />;
    };

    if (isNext) {
      return (
        <div
          className={styles.features}
          style={{
            opacity: hasFeatures ? 1 : 1
          }}
        >
          <div className={styles.chartHolder} style={{ flexFlow: "column" }}>
            {hideRight !== true && predictMode === "predict" && (
              <div className={styles.rightFeatures} style={{ width: "100%", overflow: "visible" }}>
                {this.renderPredict()}
              </div>
            )}
            {predictMode !== "forecast" && hideHotdogChart !== true && (
              <div
                className={
                  (isQuickRun ? styles.quickFeatureHolder : styles.featureHolder) +
                  " " +
                  (noBackground ? styles.featureHolderNoBackground : "")
                }
                style={{
                  ...featureStyle,
                  width: "100%",
                  height:
                    isNext && singleWindowMode && fieldSelect !== undefined
                      ? isNoInteractions
                        ? "100%"
                        : "80%"
                      : undefined
                }}
              >
                {hasFeatures || predictMode === "predict" ? (
                  <SHotdogChart
                    {...this.props}
                    bars={isSmall ? featureBars.filter((f, i) => i < 3) : featureBars}
                    fields={fields}
                    fieldValueCounts={fieldValueCounts}
                    isSmall={isSmall}
                    isNotMini={true}
                    handleSelect={(label) => !isNoInteractions && updateFieldSelect(label)}
                    updateValueSelect={(label) => !isNoInteractions && updateValueSelect(label)}
                    updateFieldOption={(field, option) => !isNoInteractions && updateFieldOption(field, option)}
                    selected={fieldSelect}
                    valueSelect={valueSelect}
                    predictMode={predictMode}
                    colSelections={suppressSelection ? {} : colSelections}
                    hoverValue={hoverValue}
                    updateHoverValue={(val) => !isNoInteractions && updateHoverValue(val)}
                    onClick={onClick ? (val) => !isNoInteractions && onClick(val) : undefined}
                    isQuickRun={isQuickRun}
                    rowCount={rowCount}
                    hideSelect={isForecast}
                    isProjectOverview
                    showColumnSelect={!hideRight}
                    isNoInteractions={isNoInteractions}
                  />
                ) : (
                  ""
                )}
              </div>
            )}
            {(hideRight !== true || predictMode === "forecast") && predictMode !== "predict" && !isNoInteractions && (
              <div
                className={styles.rightFeatures + " " + styles.nextRightFeatures}
                style={{
                  display:
                    isNext && ((fieldSelect === undefined && predictMode !== "predict") || isNoInteractions)
                      ? "none"
                      : undefined,
                  flexShrink: 1,
                  marginTop: "10px",
                  minHeight: "75%"
                }}
              >
                {predictMode === "drivers" && isSmall !== true ? (
                  determineVisualizationToShow()
                ) : predictMode === "forecast" ? (
                  <ForecastChart id={id} projectId={projectId} />
                ) : (
                  <div />
                )}
              </div>
            )}
          </div>
        </div>
      );
    }

    return (
      <div
        className={styles.features}
        style={{
          opacity: hasFeatures ? 1 : 1
        }}
      >
        <div className={styles.chartHolder}>
          {hideHotdogChart || isChat || isChatPanel ? (
            <div />
          ) : (
            predictMode !== "forecast" && (
              <div
                className={isQuickRun ? styles.quickFeatureHolder : styles.featureHolder}
                style={{
                  ...featureStyle,
                  width: isHideSelect
                    ? "100%"
                    : isSmall && predictMode === "predict"
                      ? "0%"
                      : isSmall && predictMode !== "predict"
                        ? "100%"
                        : predictMode === "forecast"
                          ? "0%"
                          : isHideSelect && predictMode === "predict"
                            ? "0%"
                            : "50%"
                }}
              >
                {isChat ? (
                  <div />
                ) : (
                  isProjectOverview !== true && (
                    <div>
                      <div>
                        {aibleBusiness ? (
                          <React.Fragment>
                            <div
                              className={styles.dTitle}
                              style={{ paddingBottom: "10px", fontSize: "16px", fontWeight: "bold" }}
                            >
                              {`Model Drivers`}
                            </div>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <div className={styles.dTitle}>{"Top Model Drivers"}</div>
                            <div className={styles.subTitle}>
                              {isTableau
                                ? "Click on a variable to view the Drill Down and Marginal Effects charts."
                                : label
                                  ? label
                                  : "Select a variable to build a predict scenario"}
                            </div>
                          </React.Fragment>
                        )}
                      </div>
                      {isModelSelect && !aibleBusiness ? (
                        <div className={styles.lHolder} style={{ margin: "20px 20px 10px" }}>
                          <div style={{ marginRight: "10px", fontSize: "16px" }}>{"Selected Model"}</div>
                          <div style={{ width: "100%", maxWidth: "300px" }}>
                            <Select
                              options={models.map((m) => ({
                                value: m.id,
                                label: m.label
                              }))}
                              value={
                                model
                                  ? {
                                      value: model.id,
                                      label: model.label
                                    }
                                  : undefined
                              }
                              onChange={(val) => updateSelectedModel(val.value)}
                              styles={{
                                menu: (provided) => ({
                                  ...provided,
                                  zIndex: 100
                                })
                              }}
                              isSearchable={false}
                            />
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      <div className={styles.lHolder}>
                        <div className={styles.legend}>
                          <div className={styles.dFieldPredict}>
                            <div className={styles.dItem}>
                              <span className={styles.dIconBad}>
                                <FontAwesomeIcon icon={faArrowDown} />
                              </span>
                            </div>
                            <div className={styles.dItem}>{"Decrease"}</div>
                          </div>
                          <div className={styles.dFieldPredict}>
                            <div className={styles.dItem}>
                              <span className={styles.dIconGood}>
                                <FontAwesomeIcon icon={faArrowUp} />
                              </span>
                            </div>
                            <div className={styles.dItem}>{"Increase"}</div>
                          </div>
                        </div>
                        {isHideSelect !== true && !isForecast && isResults !== true && (
                          <div className={styles.valLegend}>{"Selected Value"}</div>
                        )}
                      </div>
                    </div>
                  )
                )}
                {isChat ? (
                  <div />
                ) : hasFeatures || predictMode === "predict" ? (
                  <SHotdogChart
                    {...this.props}
                    bars={isSmall ? featureBars.filter((f, i) => i < 3) : featureBars}
                    fields={fields}
                    isSmall={isSmall}
                    isNotMini={true}
                    handleSelect={(label) => updateFieldSelect(label)}
                    updateValueSelect={(label) => updateValueSelect(label)}
                    updateFieldOption={(field, option) => updateFieldOption(field, option)}
                    selected={fieldSelect}
                    valueSelect={valueSelect}
                    predictMode={predictMode}
                    colSelections={colSelections}
                    hoverValue={hoverValue}
                    updateHoverValue={(val) => updateHoverValue(val)}
                    onClick={onClick ? (val) => onClick(val) : undefined}
                    isQuickRun={isQuickRun}
                    rowCount={rowCount}
                    hideSelect={isForecast}
                    isNoInteractions={isNoInteractions}
                  />
                ) : (
                  ""
                )}
              </div>
            )
          )}
          {(hideRight !== true || predictMode === "forecast") && (
            <div
              className={styles.rightFeatures}
              style={{
                overflow: isConsumer ? "visible" : "hidden",
                width:
                  isChat || isChatPanel
                    ? "100%"
                    : isHideSelect
                      ? "0%"
                      : !hasFeatures
                        ? "0%"
                        : isSmall && predictMode === "predict"
                          ? "100%"
                          : isSmall && predictMode !== "prediction"
                            ? "0%"
                            : predictMode === "forecast"
                              ? "100%"
                              : isHideSelect && predictMode === "predict"
                                ? "100%"
                                : "50%"
              }}
            >
              {predictMode === "drivers" && isSmall !== true ? (
                determineVisualizationToShow()
              ) : predictMode === "predict" ? (
                this.renderPredict()
              ) : predictMode === "forecast" ? (
                <ForecastChart id={id} projectId={projectId} />
              ) : (
                <div />
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}
